export default __webpack_public_path__ + "static/media/shopping-bag-balance.edfba51c.svg";